module.exports = __webpack_public_path__ + "static/IMG_7884-9abd85a386a212e9280053956d2bd6bf.jpg";